import React, { useState } from 'react';
import './faqall.css'; 
const faqData = [
{
  category: 'Web Development',
  questions: [
    {
      question: 'Do you create responsive websites?',
      answer: 'Yes, all our websites are mobile-friendly and adapt to all screen sizes.',
    },
    {
      question: 'Can you help with hosting and domain?',
      answer: 'Absolutely! We provide full support for domain registration and website hosting.',
    },
  ],
},

  {
    category: 'General',
    questions: [
      {
        question: 'What areas do you serve?',
        answer: 'We currently serve mohiuddinpur/siwan area.',
      },
      {
        question: 'How can I book a service?',
        answer: 'You can book online, via app, or by phone.',
      },
    ],
  },
  {
    category: 'Appliance Repair',
    questions: [
      {
        question: 'Which appliances do you repair?',
        answer: 'We repair refrigerators, washers, ovens, and more.',
      },
      {
        question: 'Do you provide replacement parts?',
        answer: 'Yes, we use high-quality genuine parts.',
      },
    ],
  },
  {
    category: 'Painting',
    questions: [
      {
        question: 'Do you offer interior and exterior painting?',
        answer: 'Yes, we handle both for homes and businesses.',
      },
      {
        question: 'Can I choose paint colors?',
        answer: 'Absolutely! We assist with color selection.',
      },
    ],
  },
 
  {
    category: 'Online Shop',
    questions: [
      {
        question: 'What do you sell online?',
        answer: 'Tools, supplies, fixtures, and home products.',
      },
      {
        question: 'Can I track my order?',
        answer: 'Yes, tracking info is sent after shipping.',
      },
    ],
  },
];

const FAQ = () => {
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeQuestion, setActiveQuestion] = useState(null);

  const toggleCategory = (index) => {
    setActiveCategory(activeCategory === index ? null : index);
    setActiveQuestion(null); // Reset question when category changes
  };

  const toggleQuestion = (index) => {
    setActiveQuestion(activeQuestion === index ? null : index);
  };

  return (
    <div className="faq-container">
        <h1 className='text-center' style={{color:'#d4af37',backgroundColor:'#0b3d2e'}}>Frequently Asked questions</h1>
      {faqData.map((section, i) => (
        <div className="faq-category" key={i}>
          <button
            className="category-btn"
            onClick={() => toggleCategory(i)}
          >
            {section.category}
            <span>{activeCategory === i ? '▲' : '▼'}</span>
          </button>

          {activeCategory === i && (
            <div className="faq-items">
              {section.questions.map((faq, j) => (
                <div key={j} className="faq-item">
                  <div
                    className="faq-question"
                    onClick={() => toggleQuestion(j)}
                  >
                    {faq.question}
                    <span>{activeQuestion === j ? '-' : '+'}</span>
                  </div>
                  {activeQuestion === j && (
                    <div className="faq-answer">{faq.answer}</div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQ;
